export const calculateMaterialsDowntheLine = (stepId, steps) => {
    let materialCount = steps.filter(o => o.id==stepId).map(o => o.refMaterialsIn.length).reduce(function(a, b) { return a + b; }, 0);
    
    materialCount += steps.filter(o => o.end.includes(stepId)).map(o => o.refMaterialsIn.length).reduce(function(a, b) { return a + b; }, 0)
    
    materialCount += steps.filter(o => o.end.includes(stepId)).map(o => calculateMaterialsDowntheLine(o.id, steps)).reduce(function(a, b) { return a + b; }, 0)
   
    return materialCount
}

export const calculatePartnersDowntheLine = (stepId, steps) => {
    let partnersCount = 0;
    
    partnersCount += steps.filter(o => o.end.includes(stepId)).map(o => o.refPartner.length).reduce(function(a, b) { return a + b; }, 0)
    
    partnersCount += steps.filter(o => o.end.includes(stepId)).map(o => calculatePartnersDowntheLine(o.id, steps)).reduce(function(a, b) { return a + b; }, 0)
   
    return partnersCount
}